<template>
  <vx-card no-shadow>
    <h2 class="mb-6">General</h2>
    <div class="vx-row">
      <div class="vx-col sm:w-1/5 w-full">
        <span>When</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full" style="display: flex">
        <div class="my-4">
          <small class="date-label">Date (opening date)</small>
          <flat-pickr
            class="p-3 s-inputx vs-input--input flex"
            :config="configDate"
            v-model="report.date"
            placeholder="Ex: Nov 18..."
            style="display: flex"
          />
        </div>

        <div class="my-4" style="margin-left: 8px">
          <small class="date-label">Closing time</small>
          <flat-pickr
            class="p-3 s-inputx vs-input--input flex"
            :config="configClosingDate"
            v-model="report.closingTime"
            placeholder="Ex: 04:00..."
            style="display: flex"
          />
        </div>
        <div class="my-4" style="margin-left: 8px">
          <small class="date-label">Last guest out</small>
          <flat-pickr
            class="p-3 s-inputx vs-input--input flex"
            :config="configLastGuestDate"
            v-model="report.lastGuestOutTime"
            placeholder="Ex: 04:00..."
            style="display: flex"
          />
        </div>
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Arrangement</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-input class="inputx w-full" placeholder="Any arrangements held today" v-model="report.arrangement" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>General comments</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea class="inputx w-full" label="General comments for the day" v-model="report.generalComments" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Personale comments</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea class="inputx w-full" label="Comments about the personale" v-model="report.personaleComments" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Marketing/Guest relations</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea class="inputx w-full" label="Comments about guest relations" v-model="report.guestRelationsComments" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Gimmicks/focus</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea class="inputx w-full" label="Should we focus on something?" v-model="report.focusComments" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Defects/needs</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea class="inputx w-full" label="Did anything break or do you need something?" v-model="report.defectsAndNeedsComments" />
        <vs-slider :min="0" :max="3" v-model="priorityValue" @change="changePriority" :color="defectsPriorityColor" />
        <span>
          Priority: <b>{{ defectsPriorityText }}</b></span
        >
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Music</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-slider :min="1" :max="5" v-model="musicValue" @change="changeMusic" />
        <span
          >Rating: <b>{{ musicScoreText }}</b></span
        >
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Safety/Clientele</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-slider :min="1" :max="5" v-model="safetyValue" @change="changeSafety" />
        <span
          >Rating: <b>{{ safetyScoreText }}</b></span
        >
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col lg:w-1/1 w-full">
        <h5>Photo(s) of the facade</h5>
        <report-images :reportId="report.id" :imageUrls="report.imageUrls" style="width: 100%" />
      </div>
    </div>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>
import Vue from "vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
// import ReportImages from "./ReportImages.vue";
const ReportImages = () => import("./ReportImages.vue");

export default {
  components: {
    flatPickr,
    ReportImages
  },
  props: {
    report: Object
  },
  data() {
    return {
      priorityValue: this.report.defectsPriority,
      musicValue: this.report.musicRating,
      safetyValue: this.report.safetyRating,
      configDate: {
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "M j, Y",
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {}
      },
      configClosingDate: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
        dateFormat: "H:i",
        defaultHour: 4,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {}
      },
      configLastGuestDate: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
        dateFormat: "H:i",
        defaultHour: 4,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {}
      }
    };
  },
  computed: {
    musicScoreText() {
      switch (this.musicValue) {
        case 1:
          return "Awful";
        case 2:
          return "Not good";
        case 3:
          return "Alright";
        case 4:
          return "Good";
        case 5:
          return "Awesome";
        default:
          return "Not rated";
      }
    },
    safetyScoreText() {
      switch (this.safetyValue) {
        case 1:
          return "Awful";
        case 2:
          return "Not good";
        case 3:
          return "Alright";
        case 4:
          return "Good";
        case 5:
          return "Perfect";
        default:
          return "Not rated";
      }
    },
    defectsPriorityText() {
      switch (this.priorityValue) {
        case 0:
          return "None";
        case 1:
          return "Low";
        case 2:
          return "Medium";
        case 3:
          return "High";
        default:
          return "None";
      }
    },
    defectsPriorityColor() {
      switch (this.priorityValue) {
        case 0:
          return "grey";
        case 1:
          return "#28C76F";
        case 2:
          return "#FF9F43";
        case 3:
          return "#EA5455";
        default:
          return "grey";
      }
    }
  },
  methods: {
    changePriority(value) {
      Vue.set(this.report, "defectsPriority", value);
    },
    changeMusic(value) {
      Vue.set(this.report, "musicRating", value);
    },
    changeSafety(value) {
      Vue.set(this.report, "safetyRating", value);
    },
    saveInfo() {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#save-button",
        scale: 0.45
      });
      const dto = {
        id: this.report.id,
        userId: this.report.userId,
        venueId: this.report.venueId,
        date: moment.utc(this.report.date).format(),
        closingTime: this.report.closingTime,
        lastGuestOutTime: this.report.lastGuestOutTime,
        arrangement: this.report.arrangement,
        generalComments: this.report.generalComments,
        personaleComments: this.report.personaleComments,
        guestRelationsComments: this.report.guestRelationsComments,
        focusComments: this.report.focusComments,
        defectsAndNeedsComments: this.report.defectsAndNeedsComments,
        defectsPriority: this.report.defectsPriority,
        musicRating: this.report.musicRating,
        safetyRating: this.report.safetyRating,
        imageUrls: this.report.imageUrls,
        recipientRole: this.report.recipientRole,
        eodReportNumbers: this.report.eodReportNumbers
      };

      console.log(this.report, dto);
      this.$store
        .dispatch("eodReports/updateEodReport", dto)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "General info saved"
          });
        })
        .catch(err => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not save general info: " + err
          });
        })
        .finally(() => {
          this.$vs.loading.close("#save-button > .con-vs-loading");
        });
    }
  },
  created() {}
};
</script>

<style style="scss" scoped>
</style>